var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"value":_vm.value,"items":_vm.dayOfWeekList},on:{"input":function($event){return _vm.emit('change', $event)}}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }